import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Page from "../layouts/main";
import Home from "../sections/Home/Home";
import Products from "../sections/Products/Products";
import Services from "../sections/Services/Services";
import Contact from "../sections/Contact/Contact";
import Mission from "../sections/Mission/Mission";
import Footer from "../components/Footer/Footer";
import settings from "../util/settings";
import Head from "next/head";
import { TweenMax, TimelineMax, EasePack, TextPlugin} from 'gsap';
import ReactGA from 'react-ga';
import Plx from 'react-plx';
import data from '../static/json/data.json';

class Index extends Component {

  constructor(props) {
    super(props);
    this.state = {
      animDone: true
    }
    this.sections = []
  }

  componentDidMount() {
    if (!settings.isServer()) {
      var urlChops = window.location.pathname.split("/"),
          lastChop = "";
      for (var i = urlChops.length - 1; i > 0; i--) {
        if (urlChops[i] && urlChops[i] != "") {
          lastChop = urlChops[i]
          break
        }
      }
      if (urlChops.length > 1) {
        this.scrollTo(lastChop)
      }
    }
  }

  componentWillUnmount() {
  }

  setAnimDone = () => {
    this.setState({animDone: true})
  }

  getSectionName = (index) => {
    return (index > -1 && index <= this.sections.length) ? this.sections[index].id.substr(this.sections[index].id.indexOf("-")+1) : "";
  }

  getSectionIndex = (name) => {
    if (name) {
      for (var i = 0; i < this.sections.length; i++) {
        if (this.sections[i].id.indexOf(name) > -1) return i;
      }
    }
    return -1;
  }

  appendSection = (section, index) => {
    this.sections[index] = section
  }

  scrollTo = (section)=> {
    if (this.Page) this.Page.scrollToSection('section-' + section)
  }

  render() {
    this.sections = []
    return (
      <Page id="Home" menu={{show: this.state.animDone}} ref={el => this.Page = el}>

        <Home refSetter={this.appendSection}
                 scrollTo={this.scrollTo}
                 animDone={this.state.animDone}
                 setState={this.setAnimDone} />

        { this.state.animDone && (
            <Fragment>
              <Products data={data.projects} router={this.context.router} refSetter={this.appendSection} />
              <Services data={data.projects} refSetter={this.appendSection} />
              <Mission refSetter={this.appendSection} />
              <Contact refSetter={this.appendSection} />
              <Footer />
            </Fragment>
          )
        }

      </Page>
    )
  }
}


Index.contextTypes = {
  router: PropTypes.object.isRequired
};

export default Index



// WEBPACK FOOTER //
// ./pages/index.js